import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowRight, faChevronDown } from '@fortawesome/free-solid-svg-icons';
import { faWhatsapp } from '@fortawesome/free-brands-svg-icons';
import { WA, STATS } from '../../constants';
import { ExternalLink } from '../ui';

const Hero = () => {
  return (
    <section id="hero" className="relative min-h-[100svh] flex items-center justify-center overflow-hidden bg-mesh pt-20 pb-8">
      {/* Background Elements */}
      <div className="absolute inset-0 overflow-hidden pointer-events-none">
        <div className="absolute top-10 left-5 w-40 h-40 sm:w-72 sm:h-72 bg-goshine-orange/10 rounded-full blur-2xl sm:blur-3xl" />
        <div className="absolute bottom-10 right-5 w-48 h-48 sm:w-96 sm:h-96 bg-goshine-purple-light/10 rounded-full blur-2xl sm:blur-3xl" />
      </div>

      <div className="container mx-auto px-5 sm:px-6 py-6 relative z-10">
        <div className="max-w-4xl mx-auto text-center flex flex-col items-center justify-center">
          {/* Badge */}
          <div className="inline-flex items-center gap-2 bg-white/10 border border-white/10 rounded-full px-4 py-2 mb-5 sm:mb-6">
            <span className="w-2 h-2 bg-goshine-orange rounded-full animate-pulse" />
            <span className="text-[11px] sm:text-sm text-gray-300 font-medium">Estética Automotiva Premium</span>
          </div>

          {/* Heading */}
          <h1 className="text-[26px] sm:text-4xl md:text-5xl lg:text-7xl font-bold mb-3 sm:mb-6 leading-[1.15] sm:leading-tight">
            Seu carro merece
            <span className="block gradient-text mt-1">brilhar como novo</span>
          </h1>

          {/* Description */}
          <p className="text-[14px] sm:text-lg md:text-xl text-gray-400 mb-6 sm:mb-8 max-w-xs sm:max-w-xl mx-auto leading-relaxed">
            Vitrificação, polimento e higienização com tecnologia de ponta em Florianópolis.
          </p>

          {/* Stats Grid */}
          <div className="grid grid-cols-2 gap-3 w-full max-w-sm lg:max-w-3xl sm:max-w-xl sm:grid-cols-4 sm:gap-6 mb-8 sm:mb-0 sm:order-last sm:mt-16">
            {STATS.map((stat, index) => (
              <div 
                key={index} 
                className="relative overflow-hidden bg-gradient-to-br from-white/10 to-white/5 border border-white/10 rounded-2xl p-4 lg:p-8 sm:p-5 text-center group hover:border-goshine-orange/30 transition-colors duration-300"
              >
                <div className="absolute inset-0 bg-gradient-to-br from-goshine-orange/10 to-transparent opacity-0 group-hover:opacity-100 transition-opacity" />
                <div className="relative">
                  <div className="text-2xl sm:text-3xl lg:text-5xl font-bold gradient-text leading-none mb-1 lg:mb-2">
                    {stat.number}
                  </div>
                  <div className="text-[11px] sm:text-xs lg:text-sm text-gray-300 font-medium uppercase tracking-wider">
                    {stat.label}
                  </div>
                </div>
              </div>
            ))}
          </div>

          {/* CTA Buttons */}
          <div className="flex flex-col sm:flex-row gap-2.5 sm:gap-4 lg:gap-5 w-full sm:w-auto sm:justify-center sm:order-none">
            <ExternalLink 
              href={WA} 
              className="inline-flex items-center justify-center gap-2 lg:gap-3 bg-green-500 hover:bg-green-600 text-white font-semibold text-sm sm:text-base lg:text-lg py-3 sm:py-4 lg:py-5 px-5 sm:px-5 lg:px-5 rounded-full transition-colors active:opacity-80 hover:shadow-xl hover:shadow-green-500/30"
            >
              <FontAwesomeIcon icon={faWhatsapp} className="text-base sm:text-lg lg:text-xl" />
              <span>Agendar pelo WhatsApp</span>
            </ExternalLink>
            <a 
              href="#servicos" 
              className="inline-flex items-center justify-center gap-2 text-gray-300 hover:text-white text-sm py-2.5 sm:py-4 lg:py-5 sm:px-8 lg:px-10 sm:border-2 sm:border-goshine-orange sm:text-goshine-orange sm:hover:bg-goshine-orange sm:hover:text-white sm:rounded-full sm:text-base lg:text-lg transition-colors"
            >
              <span>Ver Serviços</span>
              <FontAwesomeIcon icon={faArrowRight} className="text-xs sm:hidden" />
            </a>
          </div>
        </div>
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-6 left-1/2 -translate-x-1/2 animate-bounce hidden sm:block">
        <a href="#galeria" className="text-gray-500 hover:text-goshine-orange transition-colors">
          <FontAwesomeIcon icon={faChevronDown} className="text-xl" />
        </a>
      </div>
    </section>
  );
};

export default Hero;
